import {createContext} from 'react';

interface SharedBackdropContextValue {
  register: () => () => void;
  count: number;
}

export const SharedBackdropContext = createContext<SharedBackdropContextValue>({
  register: () => () => {},
  count: 0,
});
SharedBackdropContext.displayName = 'SharedBackdrop';
